import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { MainLayout } from './components/Layout';
// Navbar y Footer reemplazados por MainLayout con Sidebar
import AssetsView from './components/AssetsView';
import EmployeesView from './components/EmployeesView';
import SmartphonesView from './components/SmartphonesView';
import TabletsView from './components/TabletsView';
import PrintersView from './components/PrintersView';
import ExtensionsDirectoryView from './components/ExtensionsDirectoryView';
import EstacionamientoView from './components/EstacionamientoView';
import NetworksView from './components/NetworksWrapper';
import ServersView from './components/ServersView';
import MaintenanceView from './components/MaintenanceView';
import DocumentsView from './components/DocumentsView';
import EventosMainView from './components/EventosMainView';
import VacantesView from './components/VacantesView';
import OrganizationView from './components/OrganizationView';
import HomeView from './components/HomeView';
import RoomReservationView from './components/RoomReservationView';
import TaxiRequestView from './components/TaxiRequestView';
import ViaticosView from './components/ViaticosView';
import CalendarioCierreView from './components/CalendarioCierreView';
import VentaEspecialView from './components/VentaEspecialView';
import BitacoraView from './components/Bitacora/BitacoraView';
import EquiposMovilesView from './components/EquiposMoviles/EquiposMovilesView';
import PresupuestosDashboardView from './components/Presupuestos/PresupuestosDashboardView';
import PresupuestoTelefoniaView from './components/Presupuestos/PresupuestoTelefoniaView';
import PresupuestoGeneralView from './components/Presupuestos/PresupuestoGeneralView';
import PresupuestoImpresorasView from './components/Presupuestos/PresupuestoImpresorasView';
import PresupuestoInternetView from './components/Presupuestos/PresupuestoInternetView';
import PresupuestoStarlinkView from './components/Presupuestos/PresupuestoStarlinkView';
import PresupuestoComprasView from './components/Presupuestos/PresupuestoComprasView';
import PresupuestoConsultoriaView from './components/Presupuestos/PresupuestoConsultoriaView';
import EncuestasProductoView from './components/EncuestasProductoView';
import ComingSoonLanding from './components/ComingSoonLanding';
import BlankPage from './components/BlankPage';
import SolicitudComidaView from './components/SolicitudComidaView';
import RequisicionComprasView from './components/RequisicionComprasView';
import SolicitudPapeleriaView from './components/SolicitudPapeleriaView';
import SuraReportaView from './components/SuraReportaView';
import LoginView from './components/LoginView';
import PrivateRoute from './components/PrivateRoute';
import CredentialsView from './components/CredentialsView';
import SettingsView from './components/SettingsView';
import EncuestaCasualView from './components/EncuestaCasualView';
import EncuestaInvitadoView from './components/EncuestaInvitadoView';
import VerificarConstanciaView from './components/VerificarConstanciaView';
import NotificationsView from './components/NotificationsView';
import ChatView from './components/ChatView';
import TalleresView from './components/TalleresView';
import ConstanciaTrabajoView from './components/ConstanciaTrabajoView';
import PermisosView from './components/PermisosView';
import VacacionesView from './components/VacacionesView';
import FirmasView from './components/FirmasView';
import AsistenciaView from './components/asistencia/AsistenciaView';
import PuertasView from './components/puertas/PuertasView';
import TicketsSoporte from './components/TicketsSoporte';
import SolicitudServicio from './components/SolicitudServicio';
import MeetingRecordingView from './components/MeetingRecordingView';
import ProyectosView from './components/Proyectos/ProyectosView';
import ProyectosHomeView from './components/Proyectos/ProyectosHomeView';
import ProyectoView from './components/Proyectos/ProyectoView';
import ProyectoBoardView from './components/Proyectos/ProyectoBoardView';
import ProyectoListaView from './components/Proyectos/ProyectoListaView';
import ProyectoCalendarioView from './components/Proyectos/ProyectoCalendarioView';
import ProyectoGanttView from './components/Proyectos/ProyectoGanttView';
import ProyectoRedView from './components/Proyectos/ProyectoRedView';
import ProyectoConfiguracionView from './components/Proyectos/ProyectoConfiguracionView';
import MisTareasView from './components/Proyectos/MisTareasView';
import CalendarioGlobalView from './components/Proyectos/CalendarioGlobalView';
import GanttGlobalView from './components/Proyectos/GanttGlobalView';
import RoadmapGlobalView from './components/Proyectos/RoadmapGlobalView';
import PlantillasView from './components/Proyectos/plantillas/PlantillasView';
import MetricasView from './components/Proyectos/metricas/MetricasView';
import ProductionGate from './components/ProductionGate';
import UniversalSearchModal from './components/UniversalSearchModal';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import { NotificationProvider, useNotifications } from './context/NotificationContext';
import { ChatProvider, useChat } from './context/ChatContext';
import { CallProvider } from './context/CallContext';
import { PermissionsProvider } from './context/PermissionsContext';
import CallOverlay from './components/Calls/CallOverlay';
import { Toaster } from 'react-hot-toast';
import { ALTO_BARRA } from './components/Layout/BarraEscritorio';
import './App.css';

// Mapeo de rutas a títulos
const ROUTE_TITLES = {
  '/inicio': 'Inicio - Centro SURA',
  '/extensions-directory': 'Directorio - Centro SURA',
  '/login': 'Iniciar Sesion - Centro SURA',
  '/empleados': 'Empleados - Centro SURA',
  '/vacantes': 'Vacantes - Centro SURA',
  '/organigrama': 'Estructura Organizativa - Centro SURA',
  '/equipos': 'Equipos - Centro SURA',
  '/smartphones': 'Smartphones - Centro SURA',
  '/tablets': 'Tablets - Centro SURA',
  '/impresoras': 'Impresoras - Centro SURA',
  '/redes': 'Redes - Centro SURA',
  '/servidores': 'Monitoreo de Servidores - Centro SURA',
  '/documentos': 'Documentos - Centro SURA',
  '/mantenimientos': 'Mantenimientos - Centro SURA',
  '/eventos': 'Eventos - Centro SURA',
  '/reserva-salas': 'Reserva de Salas - Centro SURA',
  '/solicitud-taxi': 'Solicitud de Taxi - Centro SURA',
  '/solicitud-hospedaje': 'Solicitud de Hospedaje - Centro SURA',
  '/solicitud-viaticos': 'Gestión de Viáticos - Centro SURA',
  '/calendario-cierre': 'Calendario de Cierre - Centro SURA',
  '/encuestas-producto': 'Encuestas de Productos - Centro SURA',
  '/academia-sura': 'Academia SURA - Centro SURA',
  '/credenciales': 'Bóveda de Contraseñas - Centro SURA',
  '/grabacion-reuniones': 'Minutas Inteligentes - Centro SURA',
  '/soporte-ti': 'Tickets - Centro SURA',
  '/solicitud-comida': 'Solicitud de Comida (CDN) - Centro SURA',
  '/solicitud-servicio': 'Servicios Generales - Centro SURA',
  '/requisicion-compras': 'Requisición a Compras - Centro SURA',
  '/solicitud-papeleria': 'Solicitud de Papelería - Centro SURA',
  '/sura-reporta': 'Sura Reporta - Centro SURA',
  '/ajustes': 'Ajustes - Centro SURA',
  '/notificaciones': 'Notificaciones - Centro SURA',
  '/chat': 'Chat - Centro SURA',
  '/talleres-cursos': 'Talleres y Cursos - Centro SURA',
  '/constancia-trabajo': 'Constancia de Trabajo - Centro SURA',
  '/verificar': 'Verificar constancia - SURA de Venezuela',
  '/solicitud-permisos': 'Solicitud de Permisos - Centro SURA',
  '/solicitud-vacaciones': 'Solicitud de Vacaciones - Centro SURA',
  '/firmas': 'Firmas Digitales - Centro SURA',
  '/asistencia': 'Asistencia - Centro SURA',
  '/puertas': 'Puertas - Centro SURA',
  '/encuestacasual': 'Encuesta IA - Centro SURA',
  '/productos-sura': 'Productos SURA - Centro SURA',
  '/estacionamiento': 'Estacionamiento - Centro SURA',
  '/coming-soon': 'Próximamente - Centro SURA',
  '/proyectos': 'Proyectos - Centro SURA',
  '/proyectos/mis-tareas': 'Mis tareas - Centro SURA',
  '/proyectos/calendario': 'Calendario - Centro SURA',
  '/proyectos/gantt': 'Gantt - Centro SURA',
  '/proyectos/roadmap': 'Roadmap - Centro SURA',
  '/proyectos/metricas': 'Métricas - Centro SURA'
};

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { setNavigate, unreadCount: notificationUnreadCount } = useNotifications();
  const { unreadCount: chatUnreadCount } = useChat();

  // Registrar navigate para que el context de notificaciones pueda navegar
  React.useEffect(() => {
    setNavigate(navigate);
  }, [navigate, setNavigate]);

  React.useEffect(() => {
    const baseTitle = ROUTE_TITLES[location.pathname]
      || (location.pathname.startsWith('/verificar/') ? ROUTE_TITLES['/verificar'] : null)
      || 'Centro SURA';
    const totalUnreadCount = user?.id ? notificationUnreadCount + chatUnreadCount : 0;

    document.title = totalUnreadCount > 0
      ? `(${totalUnreadCount}) ${baseTitle}`
      : baseTitle;
  }, [location.pathname, notificationUnreadCount, chatUnreadCount, user?.id]);

  // Rutas que no usan el layout principal (login, directorio publico, encuesta)
  const noLayoutRoutes = ['/login', '/encuestacasual', '/coming-soon'];
  // Links de invitados externos a encuestas: publicos, sin sesion ni layout.
  const esEncuestaInvitado = location.pathname.startsWith('/encuesta/i/');
  // Verificacion publica de constancias (bancos, embajadas): sin sesion ni layout.
  const esVerificarConstancia = location.pathname === '/verificar' || location.pathname.startsWith('/verificar/');
  const shouldUseLayout = !noLayoutRoutes.includes(location.pathname) && !esEncuestaInvitado && !esVerificarConstancia;
  const fullBleedRoutes = ['/grabacion-reuniones', '/proyectos', '/asistencia', '/puertas'];
  const shouldUseFullBleedLayout = fullBleedRoutes.some(
    (r) => location.pathname === r || location.pathname.startsWith(r + '/')
  );
  const edgeToEdgeRoutes = ['/organigrama'];
  const shouldUseEdgeToEdge = edgeToEdgeRoutes.some(
    (r) => location.pathname === r || location.pathname.startsWith(r + '/')
  );

  // Redirigir a empleados si el usuario es de GH y está en la ruta raíz
  if (location.pathname === '/' && user?.role === 'gh') {
    return <Navigate to="/inicio" replace />;
  }

  // Redirigir a empleados si el usuario está autenticado y está en la ruta raíz
  if (location.pathname === '/' && user) {
    return <Navigate to="/inicio" replace />;
  }

  // Redirigir a login si el usuario no está autenticado y está en la ruta raíz
  if (location.pathname === '/' && !user) {
    return <Navigate to="/login" replace />;
  }

  // Rutas sin layout (login, encuesta)
  if (!shouldUseLayout) {
    return (
      <Routes>
        <Route path="/login" element={<LoginView />} />
        <Route path="/encuestacasual" element={<EncuestaCasualView />} />
        <Route path="/encuesta/i/:token" element={<EncuestaInvitadoView />} />
        <Route path="/verificar" element={<VerificarConstanciaView />} />
        <Route path="/verificar/:codigo" element={<VerificarConstanciaView />} />
        <Route path="/coming-soon" element={<ComingSoonLanding />} />
      </Routes>
    );
  }

  // Rutas con layout principal
  return (
    <>
      <MainLayout fullBleed={shouldUseFullBleedLayout} edgeToEdge={shouldUseEdgeToEdge}>
        <ProductionGate>
        <Routes>


              {/* Presupuestos (Control TI) */}
              <Route path="/presupuestos" element={<PrivateRoute><PresupuestosDashboardView /></PrivateRoute>} />
              <Route path="/presupuestos/telefonia/:id" element={<PrivateRoute><PresupuestoTelefoniaView /></PrivateRoute>} />
              <Route path="/presupuestos/impresoras/:id" element={<PrivateRoute><PresupuestoImpresorasView /></PrivateRoute>} />
              <Route path="/presupuestos/internet/:id" element={<PrivateRoute><PresupuestoInternetView /></PrivateRoute>} />
              <Route path="/presupuestos/starlink/:id" element={<PrivateRoute><PresupuestoStarlinkView /></PrivateRoute>} />
              <Route path="/presupuestos/compras/:id" element={<PrivateRoute><PresupuestoComprasView /></PrivateRoute>} />
              <Route path="/presupuestos/consultoria/:id" element={<PrivateRoute><PresupuestoConsultoriaView /></PrivateRoute>} />
              <Route path="/presupuestos/generales/:id" element={<PrivateRoute><PresupuestoGeneralView /></PrivateRoute>} />
              <Route path="/bitacora" element={<PrivateRoute><BitacoraView /></PrivateRoute>} />
              <Route path="/equipos-moviles" element={<PrivateRoute><EquiposMovilesView /></PrivateRoute>} />
        {/* Rutas Protegidas */}
        <Route path="/inicio" element={
          <PrivateRoute>
            <HomeView />
          </PrivateRoute>
        } />
        <Route path="/extensions-directory" element={
          <PrivateRoute>
            <ExtensionsDirectoryView />
          </PrivateRoute>
        } />
        <Route path="/empleados" element={
          <PrivateRoute>
            <EmployeesView />
          </PrivateRoute>
        } />
        <Route path="/vacantes" element={
          <PrivateRoute>
            <VacantesView />
          </PrivateRoute>
        } />
        <Route path="/organigrama" element={
          <PrivateRoute>
            <OrganizationView />
          </PrivateRoute>
        } />
        <Route path="/equipos" element={
          <PrivateRoute>
            <AssetsView />
          </PrivateRoute>
        } />
        <Route path="/smartphones" element={
          <PrivateRoute>
            <SmartphonesView />
          </PrivateRoute>
        } />
        <Route path="/tablets" element={
          <PrivateRoute>
            <TabletsView />
          </PrivateRoute>
        } />
        <Route path="/impresoras" element={
          <PrivateRoute>
            <PrintersView />
          </PrivateRoute>
        } />
        <Route path="/redes" element={
          <PrivateRoute>
            <NetworksView />
          </PrivateRoute>
        } />
        <Route path="/servidores" element={
          <PrivateRoute>
            <ServersView />
          </PrivateRoute>
        } />
        <Route path="/documentos" element={
          <PrivateRoute>
            <DocumentsView />
          </PrivateRoute>
        } />
        <Route path="/mantenimientos" element={
          <PrivateRoute>
            <MaintenanceView />
          </PrivateRoute>
        } />
        <Route path="/eventos" element={
          <PrivateRoute>
            <EventosMainView />
          </PrivateRoute>
        } />
        <Route path="/reserva-salas" element={
          <PrivateRoute>
            <RoomReservationView />
          </PrivateRoute>
        } />
        <Route path="/solicitud-taxi" element={
          <PrivateRoute>
            <TaxiRequestView />
          </PrivateRoute>
        } />
        <Route path="/solicitud-hospedaje" element={
          <PrivateRoute>
            <BlankPage />
          </PrivateRoute>
        } />
        <Route path="/solicitud-viaticos" element={
          <PrivateRoute>
            <ViaticosView />
          </PrivateRoute>
        } />
        <Route path="/calendario-cierre" element={
          <PrivateRoute>
            <CalendarioCierreView />
          </PrivateRoute>
        } />
        <Route path="/estacionamiento" element={<PrivateRoute><EstacionamientoView /></PrivateRoute>} />
        <Route path="/productos-sura" element={
          <PrivateRoute>
            <VentaEspecialView />
          </PrivateRoute>
        } />
        <Route path="/encuestas-producto" element={
          <PrivateRoute>
            <EncuestasProductoView />
          </PrivateRoute>
        } />
        <Route path="/academia-sura" element={
          <PrivateRoute>
            <BlankPage />
          </PrivateRoute>
        } />
        <Route path="/credenciales" element={
          <PrivateRoute>
            <CredentialsView />
          </PrivateRoute>
        } />
        <Route path="/grabacion-reuniones" element={
          <PrivateRoute>
            <MeetingRecordingView />
          </PrivateRoute>
        } />
        <Route path="/soporte-ti" element={
          <PrivateRoute>
            <TicketsSoporte />
          </PrivateRoute>
        } />
        <Route path="/solicitud-servicio" element={
          <PrivateRoute>
            <SolicitudServicio />
          </PrivateRoute>
        } />
        <Route path="/ajustes" element={
          <PrivateRoute>
            <SettingsView />
          </PrivateRoute>
        } />
        <Route path="/notificaciones" element={
          <PrivateRoute>
            <NotificationsView />
          </PrivateRoute>
        } />
        <Route path="/chat" element={
          <PrivateRoute>
            <ChatView />
          </PrivateRoute>
        } />
        <Route path="/talleres-cursos" element={
          <PrivateRoute>
            <TalleresView />
          </PrivateRoute>
        } />
        <Route path="/constancia-trabajo" element={
          <PrivateRoute>
            <ConstanciaTrabajoView />
          </PrivateRoute>
        } />
        <Route path="/solicitud-permisos" element={
          <PrivateRoute>
            <PermisosView />
          </PrivateRoute>
        } />
        <Route path="/solicitud-vacaciones" element={
          <PrivateRoute>
            <VacacionesView />
          </PrivateRoute>
        } />
        <Route path="/firmas" element={
          <PrivateRoute>
            <FirmasView />
          </PrivateRoute>
        } />
        <Route path="/asistencia" element={
          <PrivateRoute>
            <AsistenciaView />
          </PrivateRoute>
        } />
        <Route path="/puertas" element={
          <PrivateRoute>
            <PuertasView />
          </PrivateRoute>
        } />
        <Route path="/solicitud-comida" element={
          <PrivateRoute>
            <SolicitudComidaView />
          </PrivateRoute>
        } />
        <Route path="/requisicion-compras" element={
          <PrivateRoute>
            <RequisicionComprasView />
          </PrivateRoute>
        } />
        <Route path="/solicitud-papeleria" element={
          <PrivateRoute>
            <SolicitudPapeleriaView />
          </PrivateRoute>
        } />
        <Route path="/sura-reporta" element={
          <PrivateRoute>
            <SuraReportaView />
          </PrivateRoute>
        } />

        {/* Modulo de Proyectos (Project Management) */}
        <Route path="/proyectos" element={
          <PrivateRoute>
            <ProyectosView />
          </PrivateRoute>
        }>
          <Route index element={<ProyectosHomeView />} />
          <Route path="metricas" element={<MetricasView />} />
          <Route path="mis-tareas" element={<MisTareasView />} />
          <Route path="mis-tareas/tareas/:id" element={<MisTareasView />} />
          <Route path="calendario" element={<CalendarioGlobalView />} />
          <Route path="calendario/tareas/:id" element={<CalendarioGlobalView />} />
          <Route path="gantt" element={<GanttGlobalView />} />
          <Route path="gantt/tareas/:id" element={<GanttGlobalView />} />
          <Route path="roadmap" element={<RoadmapGlobalView />} />
          <Route path="plantillas" element={<PlantillasView />} />
        </Route>

        {/* Proyecto individual: board / lista / calendario / tarea */}
        <Route path="/proyectos/:slug" element={
          <PrivateRoute>
            <ProyectoView />
          </PrivateRoute>
        }>
          <Route index element={<ProyectoBoardView />} />
          <Route path="tareas/:numero" element={<ProyectoBoardView />} />
          <Route path="lista" element={<ProyectoListaView />} />
          <Route path="lista/tareas/:numero" element={<ProyectoListaView />} />
          <Route path="calendario" element={<ProyectoCalendarioView />} />
          <Route path="calendario/tareas/:numero" element={<ProyectoCalendarioView />} />
          <Route path="gantt" element={<ProyectoGanttView />} />
          <Route path="gantt/tareas/:numero" element={<ProyectoGanttView />} />
          <Route path="red" element={<ProyectoRedView />} />
          <Route path="red/tareas/:numero" element={<ProyectoRedView />} />
          <Route path="configuracion" element={<ProyectoConfiguracionView />} />
        </Route>

        {/* Ruta por defecto */}
        <Route path="/" element={
          <PrivateRoute>
            <Navigate to="/inicio" replace />
          </PrivateRoute>
        } />
        </Routes>
        </ProductionGate>
      </MainLayout>
      <UniversalSearchModal enabled={Boolean(user)} />
      <CallOverlay />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <SocketProvider>
        <NotificationProvider>
          <ChatProvider>
            <CallProvider>
            <PermissionsProvider>
            <Router>
              <AppContent />
            </Router>
            <Toaster
              position="top-right"
              containerStyle={ALTO_BARRA ? { top: 16 + ALTO_BARRA } : undefined}
              toastOptions={{
                duration: 5000,
                style: {
                  borderRadius: '12px',
                  padding: '14px 18px',
                  fontSize: '14px',
                  maxWidth: '400px',
                  boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
                },
              }}
            />
          </PermissionsProvider>
          </CallProvider>
          </ChatProvider>
        </NotificationProvider>
      </SocketProvider>
    </AuthProvider>
  );
}

export default App;
